document.addEventListener("turbo:load", function () {
  function saLoadedClickEvents() {
    document
      .querySelectorAll("[data-sa-click-event]")
      .forEach(function (element) {
        var eventName = element.getAttribute("data-sa-click-event");
        if (!window.sa_event || !window.sa_loaded) return;

        element.addEventListener("click", function (event) {
          window.sa_event(eventName);
          return true;
        });
      });
  }

  function saLoadedLinkEvents() {
    document
      .querySelectorAll("a[data-sa-link-event]")
      .forEach(function (element) {
        var href = element.getAttribute("href");
        var eventName = element.getAttribute("data-sa-link-event");
        if (!href || !window.sa_event || !window.sa_loaded) return;

        element.addEventListener("click", function (event) {
          var target = element.getAttribute("target");
          if (target === "_blank") {
            event.preventDefault();
            window.sa_event(eventName, function () {
              window.location.href = href;
            });
            return false;
          } else {
            window.sa_event(eventName);
            return true;
          }
        });
      });
  }

  function saScrollTracking() {
    let userHasScrolled = true;
    let scrollTwentyFive = true;
    let scrollFifty = true;
    let scrollSeventyFive = true;
    let scrollOneHundred = true;

    if (!window.sa_event || !window.sa_loaded) return;

    let scrollHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );
    let clientHeight = document.documentElement.clientHeight;

    window.onscroll = function (e) {
      let maxScrollHeight = (scrollHeight - clientHeight);
      window.scrollPercent = (window.pageYOffset / maxScrollHeight) * 100;

      if (userHasScrolled) {
        window.sa_event("has_scrolled");
        userHasScrolled = false;
      }
      if (window.scrollPercent >= 25 && scrollTwentyFive) {
        window.sa_event("scrolled_to_25_percent");
        scrollTwentyFive = false;
      }
      if (window.scrollPercent >= 50 && scrollFifty) {
        window.sa_event("scrolled_to_50_percent");
        scrollFifty = false;
      }
      if (window.scrollPercent >= 75 && scrollSeventyFive) {
        window.sa_event("scrolled_to_75_percent");
        scrollSeventyFive = false;
      }
      if (window.scrollPercent >= 100 && scrollOneHundred) {
        window.sa_event("scrolled_to_100_percent");
        scrollOneHundred = false;
      }
    };
  }

  if (document.readyState === "ready" || document.readyState === "complete") {
    saLoadedLinkEvents();
    saLoadedClickEvents();
    // saScrollTracking();
  } else {
    document.addEventListener("readystatechange", function (event) {
      if (event.target.readyState === "complete") saLoadedLinkEvents();
      if (event.target.readyState === "complete") saLoadedClickEvents();
      // if (event.target.readyState === "complete") saScrollTracking();
    });
  }
});